<smag-buffer *ngIf="showBuffer" [msg]="bufferMessage"></smag-buffer>
<div class="error-popup box-shadow">
  {{message}}
  <link-btn class="back-btn" *ngIf="!internalError" (click)="back()" text="{{ 'INTERFACE.ERROR_LEAVE_BUTTON' | translate }}">
  </link-btn>
</div>